module.exports = __webpack_public_path__ + "img/Picture25.f9acd6fb.png";